var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.82666 25.7001C3.82666 26.1639 4.20274 26.5401 4.66666 26.5401C5.13058 26.5401 5.50666 26.1639 5.50666 25.7001V3.29996C5.50666 2.83604 5.13058 2.45996 4.66666 2.45996C4.20274 2.45996 3.82666 2.83604 3.82666 3.29996V25.7001ZM15.7391 21.1605C16.0671 21.4887 16.599 21.4887 16.927 21.1605C17.2551 20.8325 17.2551 20.3007 16.927 19.9726L12.2943 15.3399H27.0666C27.5304 15.3399 27.9066 14.9638 27.9066 14.4999C27.9066 14.036 27.5304 13.6599 27.0666 13.6599H12.2943L16.927 9.02723C17.2551 8.69918 17.2551 8.16731 16.927 7.83928C16.599 7.51124 16.0671 7.51124 15.7391 7.83928L9.67241 13.906C9.34436 14.234 9.34436 14.7658 9.67241 15.0939L15.7391 21.1605Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.d1038e8d0a296244fc5e4258d837e70c.svg";
export { ForwardRef as ReactComponent };